webpackJsonp([58679678709237],{

/***/ 1748:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DeceasedPatientItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"DeceasedPatientItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-deceased-patient-item-edge-1edd5eac7d58f2da0357.js